const SDK_VERSION = '7.62.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
